import { axiosGet, axiosPost } from './axiosService';

export class AbsherService {
	requestVerification() {
		return axiosPost(null, 'investors/absher/request', {
			hide_success_toaster: true,
		});
	}

	getStatus() {
		return axiosGet(null, 'investors/absher/status', null, null, {
			hide_toaster: true,
		});
	}
}
